/// <reference path="./libs/phaser.d.ts" />

export namespace BattleCity
{
    export class Boot extends Phaser.State
    {
        preload()
        {
            this.load.image("preloadBar" , "./assets/preloadBar.png");
        }

        create()
        {
            this.input.maxPointers = 1;
            this.stage.disableVisibilityChange = true;

            this.scale.pageAlignHorizontally = true;
            this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

            this.game.state.start('Preloader', true, false);
        }
    }
}
